import React from "react";

interface FullScreenToggleIconProps extends React.SVGProps<SVGSVGElement> {
  isFullscreen: boolean;
}

export const FullScreenToggleIcon: React.FC<FullScreenToggleIconProps> = (props) => (
  <>
    {!props.isFullscreen ? (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="9 3 3 3 3 9"></polyline>
        <polyline points="15 3 21 3 21 9"></polyline>
        <polyline points="9 21 3 21 3 15"></polyline>
        <polyline points="15 21 21 21 21 15"></polyline>
      </svg>
    ) : (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="3 9 9 9 9 3"></polyline>
        <polyline points="21 9 15 9 15 3"></polyline>
        <polyline points="3 15 9 15 9 21"></polyline>
        <polyline points="21 15 15 15 15 21"></polyline>
      </svg>
    )}
  </>
);
